/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RemoveContractReviewerRequest = {
  properties: {
    id: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
